import type { FlightDirection } from './FlightDirectionCard'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './FlightDetailsEmptyCard.module.css'

interface FlightDetailsEmptyCardProps {
  direction: FlightDirection
  noFlightTitle: string
}

export function FlightDetailsEmptyCard({
  direction,
  noFlightTitle,
}: FlightDetailsEmptyCardProps) {
  return (
    <div className={styles.emptyCard}>
      <Icon glyph={direction === 'outbound' ? 'AirplaneTakingOff' : 'AirplaneReturn'} size={32} className={styles.emptyIcon} />
      <div>
        <Typography as="h3" variant="display-i-regular">
          {noFlightTitle}
        </Typography>
      </div>
    </div>
  )
}
